import type { ReactNode } from 'react';

import { useAuth } from '@saas-kit/lib';

import { NoWorkspacePage } from './NoWorkspacePage';

interface Props {
  children: ReactNode;
}

/**
 * Gate for the workspace shell. RequireAuth has already guaranteed a hydrated,
 * authenticated user; this guard sends a user who belongs to no tenant to the
 * no-workspace screen instead of an empty, tenant-less app shell.
 */
export function RequireTenant({ children }: Props): JSX.Element {
  const tenants = useAuth((s) => s.tenants);
  if (tenants.length === 0) return <NoWorkspacePage />;
  return <>{children}</>;
}
